module.exports = __webpack_public_path__ + "static/media/side-nav-selector.c19e4710.svg";